import React from 'react';
import { marked } from 'marked';

export interface MarkdownProps {
  /** Raw markdown string to render. */
  content: string;
  /** Optional wrapper class name. */
  className?: string;
}

function renderMarkdown(content: string): string {
  const renderer = new marked.Renderer();
  renderer.link = ({ href, title, tokens }) => {
    const text = renderer.parser.parseInline(tokens);
    const isExternal = /^https?:\/\//i.test(href || '');
    const titleAttr = title ? ` title="${title}"` : '';
    const targetAttr = isExternal ? ' target="_blank" rel="noopener noreferrer"' : '';
    return `<a href="${href}"${titleAttr}${targetAttr}>${text}</a>`;
  };
  return marked.parse(content, { async: false, gfm: true, renderer }) as string;
}

/**
 * Renders GitHub Flavored Markdown content using `marked`.
 */
export const Markdown: React.FC<MarkdownProps> = ({ content, className = '' }) => {
  const html = renderMarkdown(content);

  return (
    <div
      className={`markdown-body ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
